import { useState, useEffect } from "react";
import { authenticatedFetch } from "../../utils/api";
import { API_HOST } from "../../utils/constants";
import { useToast } from "../../context/ToastContext";

export default function useRoughCut(episodeId) {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  const loadProject = async () => {
    if (!episodeId) return;

    setLoading(true);
    try {
      const data = await authenticatedFetch(`${API_HOST}/api/rough-cut/episode/${episodeId}`);
      setProject(data);
    } catch (error) {
      toast.error("加载粗剪台失败: " + error.message, 0);
    } finally {
      setLoading(false);
    }
  };

  const saveItem = async (item, { silent = false } = {}) => {
    try {
      await authenticatedFetch(`${API_HOST}/api/rough-cut/item`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(item),
      });
      if (!silent) toast.success("保存成功");
      await loadProject();
    } catch (error) {
      toast.error("保存失败: " + error.message, 0);
      throw error;
    }
  };

  const deleteItem = async (itemId, { silent = false } = {}) => {
    try {
      await authenticatedFetch(`${API_HOST}/api/rough-cut/item/${itemId}`, {
        method: "DELETE",
      });
      if (!silent) toast.success("删除成功");
      await loadProject();
    } catch (error) {
      toast.error("删除失败: " + error.message, 0);
      throw error;
    }
  };

  useEffect(() => {
    if (episodeId) {
      loadProject();
    }
  }, [episodeId]);

  return { project, loading, saveItem, deleteItem, reload: loadProject };
}
